import { postApiV1AssetUploadSign } from '@/api/sdk.gen'
import type { AssetUploadSignData } from '@/api/types.gen'

export type UploadScene = 'avatar' | 'forum' | 'comment'

/** 上传图片到对象存储，返回访问 URL */
export async function uploadImage(file: File, scene: UploadScene): Promise<string> {
  const ext = file.name.includes('.')
    ? file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase()
    : 'jpg'
  const content_type = file.type || 'image/jpeg'

  const res = await postApiV1AssetUploadSign({ body: { scene, ext, content_type } })
  const { code, data } = res.data as { code: number; data: AssetUploadSignData | null; message: string }
  if (code !== 0 || !data?.upload_url) throw new Error('获取上传签名失败')

  const uploadRes = await fetch(data.upload_url, {
    method: 'PUT',
    headers: data.headers as Record<string, string>,
    body: file,
  })
  if (!uploadRes.ok) throw new Error(`上传失败（${uploadRes.status}）`)

  return data.asset_url!
}
